import { AlertHelper } from "helpers";
import { EAlertType } from "helpers/alertHelper";

export const downloadFile = (
  source: string,
  fileName: string,
  callback: (loading: boolean) => void
) => {
  const url = `${process.env.REACT_APP_BASE_API}/v1/${source}`;
  callback(true);
  fetch(url, {
    method: "GET",
  })
    .then((response) => {
      response.arrayBuffer().then((buffer) => {
        const url = window.URL.createObjectURL(new Blob([buffer]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        setTimeout(() => {
          document.body.removeChild(link);
        }, 500);
      });
    })
    .catch((err) => {
      console.error(err);
      AlertHelper.showAlert("Tải xuống thất bại", EAlertType.ERROR);
    })
    .finally(() => {
      callback(false);
    });
};
